import { render, staticRenderFns } from "./AddressBox.vue?vue&type=template&id=9a175368&"
import script from "./AddressBox.vue?vue&type=script&lang=js&"
export * from "./AddressBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports